import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

import CopyableIdentifier from "./CopyableIdentifier";

type TraceableIdentifierLinkProps = {
  value: string | number | null | undefined;
  description: string;
  buildPath: (value: string) => string;
  buildTitle: (value: string) => string;
  displayValue?: ReactNode;
  className?: string;
  valueClassName?: string;
};

/** Shared copy + new-tab navigation behavior for operational identifiers. */
export default function TraceableIdentifierLink({
  value,
  description,
  buildPath,
  buildTitle,
  displayValue,
  className,
  valueClassName,
}: TraceableIdentifierLinkProps) {
  const normalizedValue = value == null ? "" : String(value);
  const hasValue = normalizedValue.trim().length > 0;

  return (
    <CopyableIdentifier
      value={value}
      description={description}
      className={className}
      valueClassName={valueClassName}
      displayValue={
        hasValue ? (
          <Link
            to={buildPath(normalizedValue)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-inherit underline decoration-slate-400 underline-offset-2 transition-colors hover:text-slate-700 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-500"
            title={buildTitle(normalizedValue)}
            onClick={(event) => event.stopPropagation()}
          >
            {displayValue ?? normalizedValue}
          </Link>
        ) : undefined
      }
    />
  );
}
